import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import { BreakpointValue } from "@store/Framework/Common/Utilities/breakpointValues";
import getBreakpointIndex from "@store/Framework/Common/Utilities/getBreakpointIndex";
import { StyledTheme } from "@store/Framework/Types/StyledTheme";
import merge from "lodash/merge";

export default (
    values: BreakpointValue[],
    breakpoint: BreakpointKey,
    theme: StyledTheme,
    resetValue?: BreakpointValue,
): BreakpointValue[] => {
    const count = getBreakpointIndex(breakpoint, theme) + 1;
    const base = [];

    for (let i = 0; i < count; i++) {
        base.push(null);
    }

    const result = merge(base, values.slice(0, count));

    return resetValue === null ? result : [...result, resetValue || 0];
};
